import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Subject, takeUntil } from 'rxjs';
import { BookingContentService } from 'src/app/services/bookingContentService/booking-content.service';
import { UnpaidAddOnsComponent } from 'src/app/shared/components/dialogs/unpaid-add-ons/unpaid-add-ons.component';

@Component({
  selector: 'app-home-heading-contianer',
  templateUrl: './home-heading-contianer.component.html',
  styleUrls: ['./home-heading-contianer.component.scss']
})
export class HomeHeadingContianerComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  content: any;
  constructor(private contentService: BookingContentService, private readonly _MatDialog: MatDialog) {

  }
  ngOnInit() {
    this.contentService.content$.pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
      this.content = res;
    })
  }
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
  
}
